import ShipLink from 'visuris/Data/Entities/ShipLink';
import ActionResult from 'visuris/Data/DTOs/ActionResult';
import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import * as $ from 'jquery';
import * as app from 'CMS/core/application';
import HullRepository from './HullRepository';
import ShipClaimRepository from './ShipClaimRepository';

export default class ShipLinkRepository extends BaseRepository<ShipLink> {

    // See constructor
    private GETSHIPLINKS = "";
    private GETSHIPLINK = "";
    private GETSHIPLINKBYFLAREFID = "";
    private GETSHIPLINKSFORUSER = "";
    private GETSHIPLINKSWITHHULLORSHIPCLAIMFORUSER = "";
    private GETSHIPLINKPAGESFORUSER = "";
    private UPDATEDEFAULTPRIVACYCLASS = "";
    private REMOVESHIPLINK = "";

    constructor() {
        super();
        this.GETSHIPLINKS = app.formatLocationUrl("~/visuris/api/shiplinks/getshiplinks");
        this.GETSHIPLINK = app.formatLocationUrl("~/visuris/api/shiplinks/getshiplink?linkID=");
        this.GETSHIPLINKBYFLAREFID = app.formatLocationUrl("~/visuris/api/shiplinks/getshiplink?MMSI=")
        this.GETSHIPLINKSFORUSER = app.formatLocationUrl("~/visuris/api/shiplinks/getshiplinksforuser");
        this.GETSHIPLINKSWITHHULLORSHIPCLAIMFORUSER = app.formatLocationUrl("~/visuris/api/shiplinks/GetShipLinksWithHullOrShipClaimForUser");
        this.GETSHIPLINKPAGESFORUSER = app.formatLocationUrl("~/visuris/api/shiplinks/getshiplinkpagesforuser");
        this.UPDATEDEFAULTPRIVACYCLASS = app.formatLocationUrl("~/visuris/api/shiplinks/updatedefaultprivacyclass");
        this.REMOVESHIPLINK = app.formatLocationUrl("~/visuris/api/shiplinks/removeshiplink");
    }

    public list(): Promise<ShipLink[]> {
        return new Promise<ShipLink[]>((resolve, reject) => {
            var $get = $.get(this.GETSHIPLINKS);
            $get.then((data) => {
                var shipLinks: ShipLink[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    shipLinks.push(ShipLinkRepository.fromDTO(item));
                }
                resolve(shipLinks);
            }, () => {
                reject();
            });
        });
    }

    public get(id: string): Promise<ShipLink> {
        return new Promise<ShipLink>((resolve, reject) => {
            var $get = $.get(this.GETSHIPLINK + id);
            $get.then((data) => {
                resolve(ShipLinkRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public getByFlarefId(flarefId: number, MMSI: string, shipName: string): Promise<ShipLink> {
        return new Promise<ShipLink>((resolve, reject) => {
            var $get = $.get(this.GETSHIPLINKBYFLAREFID + MMSI + "&flarefID=" + flarefId + "&shipName=" + shipName);
            $get.then((data) => {
                resolve(ShipLinkRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public getShipLinksForUser(userId?: string): Promise<ShipLink[]> {
        return new Promise<ShipLink[]>((resolve, reject) => {
            var url = this.GETSHIPLINKSFORUSER + (userId != null ? ('?userID=' + userId) : '');
            var $get = $.get(url);
            $get.then((data) => {
                var shipLinks: ShipLink[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    shipLinks.push(ShipLinkRepository.fromDTO(item));
                }
                resolve(shipLinks);
            }, () => {
                reject();
            });
        });
    }

    public getShipLinksWithHullOrShipClaimForUser(userId?: string): Promise<ShipLink[]> {
        return new Promise<ShipLink[]>((resolve, reject) => {
            const url = this.GETSHIPLINKSWITHHULLORSHIPCLAIMFORUSER + (userId != null ? ('?userID=' + userId) : '');
            const $get = $.get(url);
            $get.then((data) => {
                const shipLinks: ShipLink[] = [];
                for (const item of data) {
                    shipLinks.push(ShipLinkRepository.fromDTO(item));
                }
                resolve(shipLinks);
            }, () => {
                reject();
            });
        });
    }

    public getShipLinkPagesForUser(): Promise<any> {
        return new Promise<any[]>((resolve, reject) => {
            var url = this.GETSHIPLINKPAGESFORUSER;
            var $get = $.get(url);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public updateDefaultPrivacyClass(shipLink: ShipLink): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.UPDATEDEFAULTPRIVACYCLASS, data: JSON.stringify(shipLink), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public removeShipLink(shipLink: ShipLink): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.REMOVESHIPLINK, data: JSON.stringify(shipLink), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public static fromDTO(item: any): ShipLink {
        const link = new ShipLink();
        link.id = item.id;
        link.actualFlaRefID = item.actualFlaRefID;
        link.idType = item.idType;
        link.idNumber = item.idNumber;
        link.immatriculationNumber = item.immatriculationNumber;
        link.mmsi = item.mmsi;
        link.imo = item.imo;
        link.ofs = item.ofs;
        link.ern = item.ern;
        link.eni = item.eni;
        link.hin = item.hin;
        link.cin = item.cin;
        link.shipName = item.shipName;
        link.weborganisationID = item.weborganisationID;
        link.weborganisationName = item.weborganisationName;
        link.matchID = item.matchID;
        link.originalFlaRefID = item.originalFlaRefID;
        link.defaultPrivacyClass = item.defaultPrivacyClass;
        link.defaultPrivacyClassMessage = item.defaultPrivacyClassMessage;
        link.isRecreational = item.isRecreational;
        link.webuserID = item.webuserID;
        link.isPassenger = item.isPassenger;
        if (item.hull) {
            link.hull = HullRepository.fromDTO(item.hull);
        }
        if (item.shipClaim) {
            link.shipClaim = ShipClaimRepository.fromDTO(item.shipClaim);
        }
        return link;
    }

}